import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import Company from 'src/entities/Company';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ApiSectorOfInterestResponse } from 'src/services/entity-factory/factories/SectorOfInterestFactory';
import { ApiQuarterlyReportResponse } from 'src/services/entity-factory/factories/QuarterlyReportFactory';

export interface ApiCompanyResponse {
  id: number;
  name: string;
  cif: string | null;
  description: string;
  logo: string | null;
  website: string | null;
  email: string | null;
  phoneNumber: string | null;
  address: string | null;
  city: string | null;
  zipCode: string | null;
  province: string | null;
  country: string | null;
  establishmentDate: string | null;
  iban: string | null;
  swiftBic: string | null;
  sectorsOfInterest: Array<ApiSectorOfInterestResponse> | null;
  founderId: number;
  contactName: string | null;
  contactSurname: string | null;
  contactNationality: string | null;
  contactNif: string | null;
  contactBirthDate: Moment | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  contactAddress: string | null;
  contactZipCode: string | null;
  contactCity: string | null;
  contactProvince: string | null;
  contactCountry: string | null;
  statutes: string | null;
  statutesImage: string | null;
  quarterlyReports: Array<ApiQuarterlyReportResponse> | null;
}

interface ApiCompanyCreateRequest {
}

export class CompanyFactory extends BaseFactory<Company> {
  public toEntity(args: ApiCompanyResponse): Company {
    return new Company({
      id: args.id,
      name: args.name,
      cif: args.cif || undefined,
      description: args.description,
      logo: args.logo || undefined,
      website: args.website || undefined,
      email: args.email || undefined,
      phoneNumber: args.phoneNumber || undefined,
      address: args.address || undefined,
      city: args.city || undefined,
      zipCode: args.zipCode || undefined,
      province: args.province || undefined,
      country: args.country || undefined,
      establishmentDate: args.establishmentDate ? moment.utc(args.establishmentDate) : undefined,
      iban: args.iban || undefined,
      swiftBic: args.swiftBic || undefined,
      sectorsOfInterest: args.sectorsOfInterest ?
        args.sectorsOfInterest.map(
          (sector) => this.entityFactoryFactory.sectorOfInterestFactory.toEntity(sector)
        ) : [],
      founderId: args.founderId,
      contactName: args.contactName || undefined,
      contactSurname: args.contactSurname || undefined,
      contactNationality: args.contactNationality || undefined,
      contactNif: args.contactNif || undefined,
      contactBirthDate: args.contactBirthDate ? moment.utc(args.contactBirthDate) : undefined,
      contactEmail: args.contactEmail || undefined,
      contactPhoneNumber: args.contactPhoneNumber || undefined,
      contactAddress: args.contactAddress || undefined,
      contactZipCode: args.contactZipCode || undefined,
      contactCity: args.contactCity || undefined,
      contactProvince: args.contactProvince || undefined,
      contactCountry: args.contactCountry || undefined,
      statutes: args.statutes || undefined,
      statutesImage: args.statutesImage || undefined,
      quarterlyReports: args.quarterlyReports ?
        args.quarterlyReports.map(
          (quarterlyReport) => this.entityFactoryFactory.quarterlyReportFactory.toEntity(quarterlyReport)
        ) : [],
    });
  }

  public toRequest(company: Company): ApiCompanyCreateRequest {
    return company;
  }
}



// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/CompanyFactory.tsx